import { getterTypes } from '@/core/constants'
export default {
	[getterTypes.COMUM.GET_PARAMETRO_SISTEMA]: (state) => state.parametrosSistema,
	[getterTypes.COMUM.GET_CAMUNDA_PROCESS_KEY]: (state) => (nameProcessKey) => {
		const processKey = state.parametrosSistema[getNameProcessKey(nameProcessKey)]

		if (processKey) {
			return processKey
		}

		throw new Error('ProcessKey do fluxo bpmn não foi localizada.')
	},
	[getterTypes.COMUM.GET_ORGAO_LOGADO]: (state) => state.orgaoLogado,
	[getterTypes.COMUM.GET_CURRENT_TASK]: (state) => (processKey, businessKey) => {
		return ((state.loki.bpm.process[processKey] || {})[businessKey] || {}).currentTask
	},
	[getterTypes.COMUM.GET_STATUS_INSTANCE]: (state) => (processKey, businessKey) => {
		return ((state.loki.bpm.process[processKey] || {})[businessKey] || {}).instance?.statusInstance
	},
}

function getNameProcessKey(nameProcessKey) {
	if (typeof nameProcessKey !== 'string') {
		throw new Error(
			'nameProcessKey não é uma string, informe uma string para obter o processKey correto do fluxo bpmn.',
		)
	}

	return nameProcessKey
}
